export * from './ngx-mask-config';
